export const canCountryLink = {
  AR: 'https://ayuda.tiendanube.com/es_AR/pago-nube/como-activar-pagonube-en-mi-tienda',
  BR: 'https://atendimento.nuvemshop.com.br/pt_BR/configuracao-nuvem-pago/como-ativar-o-nuvem-pago-na-minha-loja',
  default:
    'https://ayuda.tiendanube.com/es_ES/pago-nube/como-activar-pagonube-en-mi-tienda',
};
